import { toConsumableArray as _toConsumableArray } from '../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { getTvObject } from '@costar-ui/cosmos';
import { omit } from '@costar-ui/utils';
import flexOptions, { flexAutoSizingComponentVariant } from '../../../common/flex-options/flex-options.esm.js';
import fontOptions from '../../../common/font-options/font-options.esm.js';
import radiusOptions from '../../../common/radius-options/radius-options.esm.js';
import surfaceOptions from '../../../common/surface-options/surface-options.esm.js';

var tvObject = getTvObject({
  base: flexOptions.base,
  variants: {
    direction: flexOptions.variants.direction,
    canShrink: flexOptions.variants.canShrink,
    fullWidth: flexOptions.variants.fullWidth,
    fullHeight: flexOptions.variants.fullHeight,
    fontFamily: fontOptions.fontFamily,
    fontSize: fontOptions.size,
    bordered: {
      "true": ['border', 'border-neutral', 'print:border-none'],
      "false": []
    },
    inheritFontSize: {
      "true": 'text-size-inherit'
    },
    color: surfaceOptions.color,
    radius: omit(radiusOptions.radius, ['full', '2xl', '3xl', 'xl']),
    shadow: {
      none: ['shadow-none'],
      sm: ['shadow-sm'],
      base: ['shadow'],
      md: ['shadow-md'],
      lg: ['shadow-lg'],
      xl: ['shadow-xl']
    },
    withDivider: {
      "true": ['divide-neutral', 'print:divide-none'],
      "false": []
    }
  },
  compoundVariants: [].concat(_toConsumableArray(flexAutoSizingComponentVariant), [{
    direction: 'vertical',
    withDivider: true,
    className: ['divide-y']
  }, {
    direction: 'horizontal',
    withDivider: true,
    className: ['divide-x']
  }])
});
var baseCard = tvObject;

export { baseCard as default };
//# sourceMappingURL=base-card.esm.js.map
